export const ADD_MAGAZINE = 'add_magazine'
export const CREATE_MAGAZINE = 'create_magazine'
export const EDIT_MAGAZINE = 'edit_magazine'
export const DELETE_MAGAZINE = 'delete_magazine'
export const DUPLICATE_MAGAZINE =  'duplicate_magazine'
export const TRANSFER_TEMPLATE_MAGAZINE = 'transfer_template_magazine'
export const FETCH_MAGAZINES = 'fetch_magazines'
export const SET_MAGAZINE = 'set_magazine'
export const SET_MAGAZINES = 'set_magazines'
export const FILTER_MAGAZINES = 'filter_magazines'
export const EXPORTI_PDF = 'export_pdf'
export const UPDATE_PDF_STATUS = 'update_pdf_status'
export const SET_TITLE_MAGAZINE = 'set_title_magazine'



// WEBPACK FOOTER //
// ./src/store/types/magazines.js